import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=f272d1ec&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=f272d1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f272d1ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f272d1ec')) {
      api.createRecord('f272d1ec', component.options)
    } else {
      api.reload('f272d1ec', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=f272d1ec&scoped=true&", function () {
      api.rerender('f272d1ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KWZhCM6oj2KV/JS/teamMember.vue"
export default component.exports